import { USER_TYPE } from '../constants/copy.js';
import { PERMISSIONS } from '../constants/permissions.js';
import { ADMIN_CAN_CHANGE_USER_TYPE } from '../constants/typeChange.js';

/**
 * Does the actor hold `key`? Owners and Admins bypass the grants (assumption: confirm with
 * Edgardo / backend), except for changing a user type, which an Admin only bypasses while
 * `ADMIN_CAN_CHANGE_USER_TYPE` is on; everyone else needs the key, via role or direct grant
 * (already merged into `actor.permissions` by the backend contract TBD).
 *
 * @param {{ user_type: string, permissions: string[] }|null|undefined} actor
 * @param {string} key
 * @param {{ adminCanChangeUserType?: boolean }} [options] Overrides the constant (tests).
 */
export const hasPermission = (
  actor,
  key,
  { adminCanChangeUserType = ADMIN_CAN_CHANGE_USER_TYPE } = {},
) => {
  if (!actor) return false;
  if (actor.user_type === USER_TYPE.OWNER) return true;
  if (actor.user_type === USER_TYPE.ADMIN) {
    if (key !== PERMISSIONS.MEMBERS_CHANGE_USER_TYPE || adminCanChangeUserType) return true;
  }
  return (actor.permissions ?? []).includes(key);
};
